import React from 'react';
import CustomImagesInput from '../../../../components/imageInput/CustomImageInput';
import ImageUploader from 'react-images-upload';
import { Grid, Paper, Box, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';

type IProps = {
  images: string[];
  onChange: (f: File[], a: string[]) => void;
};
function ImagesInput({ images, onChange }: IProps) {
  const t = useTranslate();
  console.log('images');
  console.log(images);
  return (
    <Paper
      sx={{
        padding: 2,
      }}
    >
      <Typography
        sx={{
          marginTop: 1,
          marginBottom: 1,
        }}
      >
        {t('images')}
      </Typography>
      <Grid container>
        {images.map((im) => (
          <Grid key={im} item lg={3} md={4} sm={6}>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img
                src={im}
                style={{
                  width: '70%',
                  height: 'auto',
                }}
              />
            </Box>
          </Grid>
        ))}

        <Grid item lg={3} md={4} sm={6}>
          <ImageUploader
            withIcon={true}
            buttonText='Choose images'
            onChange={onChange}
            withPreview={false}
            imgExtension={['.jpg', '.gif', '.png', '.gif']}
            singleImage={true}
            fileContainerStyle={{
              padding: 0,
              height: 200,
              margin: 0,
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

export default ImagesInput;
